module.exports = __webpack_public_path__ + "img/ic-authentication.13d545fe.png";